import { render, staticRenderFns } from "./LabVisitRequests.vue?vue&type=template&id=e9f8b464&"
import script from "./LabVisitRequests.vue?vue&type=script&lang=js&"
export * from "./LabVisitRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports